__turbopack_context__.v({
  "container": "_LIl9W_container",
  "research-title": "_LIl9W_research-title",
});
